angular.module("mercury.modules.stock.stockcost")
.factory('StockCost', ["$resource", "settings", function($resource, settings) {
  var StockCost = $resource(`${settings.stockHost}/internal/costs`)

  /**
   * Retrieves the stock cost at a given point in time 
   * @param {Array<strings>} itemIdTimeStrings A array of strings representing tuples holding an item ID 
   * and the DateTimeOffset to calcuate the stock cost at
   * @param {Array<strings>} recipeIdTimeStrings A array of strings representing tuples holding an recipe ID 
   * and the DateTimeOffset to calculate the stock cost at 
   */
  function get(itemIdTimeStrings, recipeIdTimeStrings) {
    return StockCost.get({
      itemIdTimeStrings: formatTimesInIdTimeStrings(itemIdTimeStrings),
      recipeIdTimeStrings: formatTimesInIdTimeStrings(recipeIdTimeStrings)
    }).$promise;
  }

  /**
   * Retrieves the stock costs of all items within a stocktake
   * @param {string} stocktakeId the ID of the stocktake
   * @returns stockCosts of all items in the given stocktake
   */
  function getFromStocktake(stocktakeId) {
    return StockCost.get({ stocktakeId }).$promise
  }

  /**
   * Ensures that the times in a string of the format "<GUID>,<DateTime>" are in ISO 8601 format
   * @param {*} idTimeStrings the Id time strings
   * @returns the id time strings with formatted times in ISO 8601
   */
  var formatTimesInIdTimeStrings = (idTimeStrings) => {
    if (idTimeStrings == undefined) return;

    var formattedStrings = []

    idTimeStrings.forEach(string => {
      var split = string.split(',')
      var timeFormattedISO8601 = moment(split[1]).format('YYYY-MM-DDTHH:mm:ss.SSSZ')

      formattedStrings.push(`${split[0]},${timeFormattedISO8601}`)
    })

    return formattedStrings;
  }

  return {
    get,
    getFromStocktake
  }
}])